module.exports = __webpack_public_path__ + "static/media/Anti-Money-Laundering.c9352f4c.jpg";